export const platform = {
  ios: 'ios',
  android: 'android',
  web: 'web'
} as const;

export type Platform = keyof typeof platform;
